module.exports = __webpack_public_path__ + "static/media/om_beard_scruff_long__square_vector.ac572803.svg";